export default "__VITE_ASSET__cb0f27cd__"